import React from 'react'
import { FormGrid, FormGroup, InfoLink, Label, Select } from '../../style'
import { Info } from 'lucide-react'
import { OrderType } from '../..'

interface MainInfosSectionProps {
  order: OrderType
  setOrder: React.Dispatch<React.SetStateAction<OrderType>>
}

const MainInfosSection: React.FC<MainInfosSectionProps> = ({ order, setOrder }) => {
  const formData = {
    suppliers: [{ name: "Fornecedor LTDA" }],
    sellers: [{ name: "Vendedor S/A" }],
    clients: [{ name: "Cliente do Brasil ME" }],
  }

  const handleChange = (field: keyof OrderType) => (e: React.ChangeEvent<HTMLSelectElement>) => {
    setOrder(prev => ({
      ...prev,
      [field]: e.target.value
    }))
  }
  
  return(
    <>
      <FormGrid>
        <FormGroup>
          <Label>Fornecedor</Label>
          <Select value={order.supplier} onChange={handleChange('supplier')}>
            <option value="">Selecione</option>
            {formData.suppliers.map(supplier => (
              <option key={supplier.name} value={supplier.name}>{supplier.name}</option>
            ))}
          </Select>
          <InfoLink>
            <Info size={16} />
            <span>Mais informações</span>
          </InfoLink>
        </FormGroup>
        <FormGroup>
          <Label>Vendedor</Label>
          <Select value={order.seller} onChange={handleChange('seller')}>
            <option value="">Selecione</option>
            {formData.sellers.map(seller => (
              <option key={seller.name} value={seller.name}>{seller.name}</option>
            ))}
          </Select>
          <InfoLink>
            <Info size={16} />
            <span>Mais informações</span>
          </InfoLink>
        </FormGroup>
        <FormGroup>
          <Label>Cliente</Label>
          <Select value={order.client} onChange={handleChange('client')}>
            <option value="">Selecione</option>
            {formData.clients.map(client => (
              <option key={client.name} value={client.name}>{client.name}</option>
            ))}
          </Select>
          <InfoLink>
            <Info size={16} />
            <span>Mais informações</span>
          </InfoLink>
        </FormGroup>
      </FormGrid>
    </>
  )
}

export default MainInfosSection